var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoxPackaging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.987 24a.39.39 0 01-.059-.004l-8.493-1a.498.498 0 01-.441-.496v-6a.5.5 0 011 0v5.556l7.493.882V10.59a.487.487 0 01.153-.45.507.507 0 01.544-.092c.181.08.303.254.303.452v13a.5.5 0 01-.5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.007 24a.503.503 0 01-.5-.5V10.75a.5.5 0 011 0v12.188l7.492-.882V16.5a.5.5 0 011 0v6a.498.498 0 01-.441.496l-8.492 1a.399.399 0 01-.059.004z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 17h-7.003a.5.5 0 01-.432-.248l-3.494-6a.497.497 0 01.014-.526.486.486 0 01.477-.222l8.496 1a.497.497 0 01.405.311l2.001 5A.5.5 0 0122.5 17zm-6.716-1h5.978l-1.616-4.038-7.207-.849z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.503 17H1.5a.499.499 0 01-.464-.686l2.001-5a.498.498 0 01.405-.311l8.496-1a.501.501 0 01.491.748l-3.494 6a.5.5 0 01-.432.249zm-6.265-1h5.978l2.846-4.887-7.207.849zM12 8a.5.5 0 01-.5-.5v-7a.5.5 0 011 0v7a.5.5 0 01-.5.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8a.5.5 0 01-.325-.12l-3.5-3a.5.5 0 11.65-.76L12 6.842l3.175-2.722a.5.5 0 11.65.76l-3.5 3A.5.5 0 0112 8z"
  })));
}

export default SvgBoxPackaging;